<template>
<b-container fluid>
  <br>
  <h1>Enter New Password</h1>
  <b-row class="justify-content-md-center">
    <b-col lg="4" sm="8" md="6">
    <b-form v-on:submit.prevent="validateEntry">
    <b-form-group
    id="fieldset-2"
    label="Password"
    label-align="left"
    label-for="password-id"
  >

    <b-form-input class="mb-4" id="password-id" v-model="password" type="password" :state="strongPassword" aria-describedby="password-help-block"></b-form-input>
    </b-form-group>
    <b-form-invalid-feedback :state="strongPassword" id="password-help-block">Passwords must have 8 characters and include uppercase characters.</b-form-invalid-feedback>

   <b-form-group
    id="fieldset-2"
    label="Confirm Password"
    label-align="left"
    label-for="password2-id"
  >

    <b-form-input class="mb-4" id="password2-id" v-model="password2" type="password" :state="matchingPassword" aria-describedby="password-help-block"></b-form-input>
    </b-form-group>
    <b-form-invalid-feedback :state="matchingPassword" id="password2-help-block">Passwords must match</b-form-invalid-feedback>

   <b-button id="submit-id" type="submit" block variant="outline-primary">Submit</b-button>
      </b-form>

    </b-col>
  </b-row>
</b-container>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "PasswordResetSubmit.vue",
        props :['code','token'],
         data() {
        return {
            password:'',
            password2:'',
            strongPassword: null
            }
        },
        computed:{
            matchingPassword(){
                if(this.password == '' || this.password2 ==''){
                    return null
                } else {
                    return this.password == this.password2
                }
            }
        },
        methods:{
          validateEntry(){
            var contains_uppercase = /[A-Z]/.test(this.password)
            var password_length = this.password.length >= 8
            var password_match = this.password == this.password2

            if(contains_uppercase && password_length && password_match){
                this.RequestUpdate()
            } else {
                this.strongPassword = false;
            }
        },
        RequestUpdate:function(){
         axios.post("/api/account/reset-submit/",{code:this.code,token:this.token,pw:this.password}).then(response => {
             if (response.data.status == 'success'){
                 this.$router.push({name: 'login', query: {a: 'resetsuccess'}})
                }
             else{
                 this.$router.push({name: 'login', query: {a: 'resetfailed'}})
             }
                });
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PasswordResetSubmit.vue